// extracted by mini-css-extract-plugin
export default {"userDetails":"styles_userDetails__hFvri","placeholder":"styles_placeholder__lhVQA"};